import { Kind } from "graphql";
export function createVariableDefinitionNode(kind, name, type) {
    const typeNode = kind === 'NamedType' ? {
        kind,
        name: {
            kind: Kind.NAME,
            value: type
        }
    } : {
        kind: Kind.NON_NULL_TYPE,
        type: {
            kind: Kind.NAMED_TYPE,
            name: {
                kind: Kind.NAME,
                value: 'Boolean'
            }
        }
    };
    return {
        kind: Kind.VARIABLE_DEFINITION,
        variable: {
            kind: Kind.VARIABLE,
            name: {
                kind: Kind.NAME,
                value: name
            }
        },
        type: typeNode
    };
}
export function getVariableName(variableDefinitionNode) {
    return variableDefinitionNode.variable.name.value;
}

//# sourceMappingURL=variable.js.map